import { Card } from 'primereact/card';
import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import ActionLink from '../components/ActionLink';
import DivContainer from '../components/DivContainer';
import InputDropdownComponent from '../components/inputs/InputDropdownComponent';
import InputTextComponent from '../components/inputs/InputTextComponent';
import YesNoDialog from '../components/YesNoDialog';
import BaseUserDetailsContainer from '../baseContainers/BaseUserDetailsContainer';
import { t } from 'i18next';
import InputCalendarComponent from '../components/inputs/InputCalendarComponent';
import moment from 'moment/moment';
import InputNumberComponent from '../components/inputs/InputNumberComponent';
import SubcontractorService from '../services/SubcontractorService';
import InputCheckboxComponent from '../components/inputs/InputCheckboxComponent';
import SettingService from '../services/SettingService';
import { TabPanel, TabView } from 'primereact/tabview';
import EmployeeAbsenceReasonService from '../services/UserAbsenceReasonService';
import DocumentTypeService from '../services/DocumentTypeService';
import EmployeeCategoryService from '../services/UserCategoryService';
import IconColorComponent from '../components/inputs/IconColorComponent';
import LogEntryService from '../services/LogEntryService';
import DocumentExpirationStatusDialog from './employee/DocumentExpirationStatusDialog';
import Constants from '../utils/constants';
import LogEntryListContainer from './LogEntryListContainer';
import InternalUserService from '../services/InternalUserService';
import UserRoleService from '../services/UserRoleService';
import UserModel from './employee/UserModel';
import UsersService from '../services/UsersService';
import { Avatar, Checkbox } from '@mui/material';
import PdfDownloadSpinner from '../components/spinner/PdfDownloadSpinner';
import { CustomMessages } from '../components/CustomMessages';
import BlockUi from '../components/waitPanel/BlockUi';
import { ConfirmDialog } from 'primereact/confirmdialog';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import InsertLinkIcon from '@mui/icons-material/InsertLink';
import CategoryIcon from '@mui/icons-material/Category';
import SecurityIcon from '@mui/icons-material/Security';
import GroupIcon from '@mui/icons-material/Group';
import { DisabledByDefault } from '@mui/icons-material';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import BadgeIcon from '@mui/icons-material/Badge';
import LockIcon from '@mui/icons-material/Lock';
import EngineeringIcon from '@mui/icons-material/Engineering';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import WidgetsIcon from '@mui/icons-material/Widgets';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import AlarmStatusIconTemplateComponent from '../components/AlarmStatusIconTemplateComponent';
import ProjectUserService from '../services/ProjectUserService';
import HelpCenterIcon from '@mui/icons-material/HelpCenter';
import { Tooltip } from 'primereact/tooltip';
import InputMultiListBoxComponent from '../components/inputs/InputMultiListBoxComponent';
import { Chip } from 'primereact/chip';
import CopyLink from './CopyLink';
import BeachAccess from '@mui/icons-material/BeachAccess';
import { withRouter } from "react-router-dom";


class UserDetailsContainer extends BaseUserDetailsContainer {
    constructor(props) {
        super(props, new UsersService());
        this.subcontractorService = new SubcontractorService();
        this.settingsService = new SettingService()
        this.absenseReasonService = new EmployeeAbsenceReasonService();
        this.documentService = new DocumentTypeService();
        this.categoryService = new EmployeeCategoryService();
        this.logEntryService = new LogEntryService();
        this.internalUserService = new InternalUserService();
        this.userRolesService = new UserRoleService()
        this.projectUserService = new ProjectUserService();

        this.contractDayMode = {
            view: 'month',
            dateFormat: 'mm-yy',
            placeholder: 'mm-yy',
            dateFormatMoment: 'MM-YYYY',
            yearNavigator: true,
        };
        const queryParams = new URLSearchParams(this.props.history.location.search);
        
        const roleExternalManager = this.authService.isUserInRole('ROLE_USER_TYPE_EXTERNAL_MANAGER');
        const currentUser = this.authService.getProfile();

        const element = new UserModel();
        element.externalManager = roleExternalManager ? { id: currentUser.subId, fullName: currentUser.name } : undefined;

        const activeIndexParam = this.navigationContext.getCallerParam('activeIndex');

        this.state = {
            activeIndex: activeIndexParam ? activeIndexParam : 0,
            dialogVisibile: false,
            showConfirmBlockDialog: false,
            showConfirmUnblockDialog: false,
            elementId: this.props.elementId,
            element: element,
            contractType: true,
            loading: false,
            statusOptions: [],
            contractTypes: [],
            linkColor: 'black',
            subcontractors: [],
            categories: [],
            absenceReasons: [],
            documentTypes: [],
            alarms: [],
            docActionDialogVisible: false,
            externalManagers: [],
            roleOptions: [],

            employeeRoles: [],
            portalLoginRoles: [],
            loginAppRoles: [],
            officeWorkersRoles: [],
            firstName: undefined,
            lastName: undefined,
        };

        this.setContractsDatesTo = this.setContractsDatesTo.bind(this);
        this.calculateMinDateForDateFrom = this.calculateMinDateForDateFrom.bind(this);
        this.calculateMinDateForDateTo = this.calculateMinDateForDateTo.bind(this);
        this.calculateMaxDateForDateFrom = this.calculateMaxDateForDateFrom.bind(this);
        this.documentStatusAction = this.documentStatusAction.bind(this);
        this.hideDocStatusDialog = this.hideDocStatusDialog.bind(this);
        this.refreshCurrentElement = this.refreshCurrentElement.bind(this);
        this.getLinkComponentIfRequired = this.getLinkComponentIfRequired.bind(this)
        this.getPhoneNumberIfRequired = this.getPhoneNumberIfRequired.bind(this);

        this.validator.addCustomRule('contract_no_duplicates', t('employee.details.vaidation_contract_no_duplicates'), (value) => {
            const dates = value.map((c) => moment(c.dateFrom).format('yyyy-MM-DD'));
            const findDuplicatesFunction = (arry) => arry.filter((item, index) => dates.indexOf(item) !== index);
            const duplicates = findDuplicatesFunction(dates);
            return duplicates.length == 0;
        });
        this.validator.addCustomRule('no_overlapping_dates', t('employee.absence.validation.no_overlapping_dates'), (value) => {
            let flag = true;
            value.forEach((x, indexX) => {
                value.forEach((y, indexY) => {

                    if (indexX !== indexY) {
                        const startDateY = moment(y.dateFrom);
                        const endDateY = moment(y.dateTo);
                        const startDateX = moment(x.dateFrom);
                        const endDateX = moment(x.dateTo);

                        if (
                            startDateX.isBetween(startDateY, endDateY) ||
                            endDateX.isBetween(startDateY, endDateY) ||
                            endDateX.isSame(endDateY) && startDateX.isSame(startDateY) ||
                            endDateX.isSame(startDateY) || startDateX.isSame(endDateY)
                        ) {
                            flag = false;
                        }
                    }
                });
            });
            return flag;
        })

        this.validator.addCustomRule('date_from_less_than_date_to', 'Data od nie moze być po dacie powrotu', (value, index) => {
            const absence = this.state.element.absences[index];
            const dateTo = absence.dateTo;
            return moment(value).isSameOrBefore(moment(dateTo));
        },
            (message, params) => message.replace(':date', params[0])
        )

        this.validator.addCustomRule('date_to_must_be_bigger_than_date_from', 'Data powrotu nie moze być przed datą od',
            (value, index) => {
                const absence = this.state.element.absences[index];
                const dateFrom = absence.dateFrom;
                return moment(value).isSameOrAfter(moment(dateFrom));
            },
            (message, params) => message.replace(':date', params[0])
        )
        this.validator.addCustomRule('contract_must_be_defined', 'Pracownik musi posiadać przynajmniej jeden kontrakt',
            (value) => {
                return value.length > 0;
            }
        )

        this.validator.addCustomRule('at_least_one_role_selected', "Pracownik musi posiadać przynajmniej jedną rolę",
            (value) => {
                const { element } = this.state;
                return element?.roles.length >= 1;
            }, (message, params) => message,
            true
        )
    }

    sortContracts(contracts) {
        contracts.sort((c1, c2) => (c1.dateFrom < c2.dateFrom ? 1 : -1));
    }

    sortDocuments(documents) {
        documents.sort((c1, c2) => (c1.dateTo < c2.dateTo ? 1 : -1));
    }
    
    sortRoles(roles){
        roles.sort((x, y) => x.id < y.id) //posortuj role po idku
    }

    getAddSucces() {
        const { t } = this.props;
        return t('employee.addUserSuccess');
    }

    getUpdateSucces() {
        const { t } = this.props;
        return t('employee.updateUserSuccess');
    }


    updateElement(data) {
        if(data && data.roles){
            this.sortRoles(data.roles);
        }
        if (data && data.contracts) {
            this.sortContracts(data.contracts);
        }
        if (data && data.documents) {
            this.sortDocuments(data.documents);
        }
        const userModel = UserModel.copy(data);
        this.setState(
            {
                element: userModel,
                lastName: userModel.lastName,
                firstName: userModel.firstName
            },
            () => {
                this.initAfterSetElement();
            }
        );
    }



    // afterAddSuccess(response) {
    //     const { viewUrl } = this.props;
    //     this.blockUi();
    //     this.persistMessage('success', '', this.getAddSucces(response));
    //     window.location.href = viewUrl + this.state.elementId;
    // }

    // afterUpdateSuccess(response) {
    //     const { viewUrl } = this.props;
    //     this.blockUi();
    //     this.persistMessage('success', '', this.getUpdateSucces(response));
    //     window.location.href = viewUrl + this.state.elementId;
    // }

    getBackLabel() {
        return <span id='back-button-label'>Wróć</span>
    }

    isFormValid(callback) {
        const initActiveIndex = this.state.activeIndex;
        const scrollableContainer = document.getElementById('main-container'); 
        const scrollPosition = scrollableContainer?.scrollTop;  

         this.setState({ activeIndex: 0 }, () => {
            if (this.validator.allValid()) {
                this.setState({ activeIndex: 1 }, () => {
                    if (this.validator.allValid()) {
                        this.setState({ activeIndex: 2 }, () => {
                            if (this.validator.allValid()) {
                                this.setState({ activeIndex: 3 }, () => {
                                    if (this.validator.allValid()) {
                                        this.setState({ activeIndex: 4 }, () => {
                                            if (this.validator.allValid()) {
                                                this.setState({ activeIndex: 5 }, () => {
                                                    if (this.validator.allValid()) {
                                                        this.setState({ activeIndex: initActiveIndex }, () => {
                                                            scrollableContainer?.scrollTo(0, scrollPosition);
                                                            callback(true);
                                                        });
                                                    } else {
                                                        callback(false);
                                                    }
                                                });
                                            } else {
                                                callback(false);
                                            }
                                        });
                                    } else {
                                        callback(false);
                                    }
                                });
                            } else {
                                callback(false);
                            }
                        });
                    } else {
                        callback(false);
                    }
                });
            } else {
                callback(false);
            }
        });
    }
    
    initBeforeSetElement() {
        this.enumService
            .getEnumList('UserActivityStatus')
            .then((statusOptions) =>
                this.setState({
                    statusOptions,
                })
            )
            .catch(() => {
                this.showErrorMessage(t('global.statusOptionsErrorMessage'));
            });

        this.enumService
            .getEnumList('UserContractType')
            .then((contractTypes) => this.setState({ contractTypes }))
            .catch(() => {
                this.showErrorMessage(t('global.contractTypesErrorMessage'));
            });

        this.settingsService
            .getValue('EMAIL_DOMAIN')
            .then((res) => {
                this.setState({
                    emailDomain: res.value
                })
            }).catch((ex) => {
                this.showErrorMessage(t('global.emailDomainErrormessage'));
            });

        this.absenseReasonService
            .getList({
                firstResult: 0, maxResults: 1000, sortField: 'reason', sortAsc: true,
                status: { enumValue: 'ACTIVE', label: "Aktywny" }
            })
            .then((data) => {
                this.setState({
                    absenceReasons: data.content
                })
            }).catch((ex) => {
                this.showErrorMessage(t('global.absenceTypesErrorMessage'));
            });;

        this.documentService.getList({
            firstResult: 0, maxResults: 1000, sortField: 'name', sortAsc: true,
            status: { enumValue: 'ACTIVE', label: "Aktywny" }
        }).then((data) => {
            this.setState({
                documentTypes: data.content
            })
        }).catch((ex) => {
            this.showErrorMessage(t('global.documentTypesErrorMessage'));
        });

        this.categoryService.getList({ status: { enumValue: 'ACTIVE' }, firstResult: 0, maxResults: 1000, sortField: 'name', sortAsc: true })
            .then(categories => this.setState({ categories: categories.content }))
            .catch(() => {
                this.showErrorMessage(t('global.categoryListErrorMessage'));
            });

        this.internalUserService.getSimpleList(['ROLE_USER_TYPE_EXTERNAL_MANAGER'])
            .then(users => this.setState({ externalManagers: users }))
            .catch(() => {
                this.showErrorMessage(t('global.externalManagerErrorMessage'));
            });

        this.userRolesService
            .getAll()
            .then((roleOptions) =>
                this.setState({
                    roleOptions,
                })
            )
            .catch(() => {
                this.showErrorMessage(t('global.rolesErrorMessage'));
            });


        this.userRolesService
            .getAll('ROLE_LOGIN_APP')
            .then((loginAppRoles) =>
                this.setState({
                    loginAppRoles,
                })
            )
            .catch(() => {
                this.showErrorMessage(t('global.rolesErrorMessage'));
            });


        this.userRolesService
            .getAll('ROLE_LOGIN_PORTAL')
            .then((portalLoginRoles) =>
                this.setState({
                    portalLoginRoles,
                })
            )
            .catch(() => {
                this.showErrorMessage(t('global.rolesErrorMessage'));
            });

        this.userRolesService
            .getAll('ROLE_USER_TYPE_EMPLOYEE')
            .then((employeeRoles) =>
                this.setState({
                    employeeRoles,
                })
            )
            .catch(() => {
                this.showErrorMessage(t('global.rolesErrorMessage'));
            });

        this.userRolesService
            .getAll('ROLE_USER_TYPE_OFFICE_WORKER')
            .then((officeWorkersRoles) =>
                this.setState({
                    officeWorkersRoles,
                })
            )
            .catch(() => {
                this.showErrorMessage(t('global.rolesErrorMessage'));
            });

        if (this.state.elementId) {
            this.projectUserService
                .getList(this.state.elementId, { firstResult: 0, maxResults: 1000, sortField: 'id', sortAsc: true })
                .then((data) => {
                    this.setState({
                        userProjects: data.content
                    })
                }).catch((ex) => {
                    this.showErrorMessage('Nie udało się pobrać wszystkich projektów użytkownika');
                });;
        }

        if (this.authService.isUserInRole('ROLE_SUBCONTRACTOR_LIST_VIEW')) {
            this.subcontractorService.getList({
                firstResult: 0, maxResults: 1000, sortField: 'id', sortAsc: true,
                status: { enumValue: 'ACTIVE', label: "Aktywny" }
            }).then((subcontractors) => {
                this.setState({ subcontractors: subcontractors.content });
            }).catch((err) => {
                this.showErrorMessage(t('global.subcontractorErrorMessage'))
            })
        }
    }


    handleGoToEdit() {
        this.blockUi();
        const { editUrl } = this.props;
        window.location.href = editUrl;
    }

    prepareFooterItems() {
        //FOOTER 

        const { editUrl } = this.props;
        const { element } = this.state;
        const result = super.prepareFooterItems();

        if (this.authService.isUserInAnyRole('ROLE_USER_EDIT') && this.props.viewMode === 'VIEW') {
            if (this.props.viewMode === 'VIEW') {
                result.push({
                    id:'edit-button',
                    label: t('details.editButton'),
                    className: 'float-right',
                    href: this.navigationContext.addNavigationContextToUrl(`${editUrl}/${element.id}`)
                });
                if (this.state.element.status.enumValue === 'ACTIVE') {
                    result.push({
                        id: 'block-button',
                        label: t('employee.details.blockButton'),
                        className: 'fullred float-right',
                        onClick: this.showBlockConfirmation,
                    });
                } else {
                    result.push({
                        label: t('employee.details.unblockButton'),
                        className: 'fullred float-right',
                        onClick: this.showUnblockConfirmation,
                    });
                }
            }
        }
        return result;
    }

    calculateMinDateForDateFrom(rowIndex) {
        const contracts = this.state.element?.contracts;
        if (contracts.length > 0) {
            const currentContract = contracts[rowIndex];
            const prevContract = contracts[rowIndex + 1];
            if (prevContract?.dateTo) {
                return moment(prevContract.dateFrom).clone().add(1, 'months').toDate();
            } else {
                return moment(currentContract.dateFrom).toDate();
            }
        }
        return null;
    }
    calculateMaxDateForDateFrom(rowIndex) {
        const contracts = this.state.element?.contracts;
        if (contracts.length > 0) {
            const currentContract = contracts[rowIndex];
            if (currentContract.dateTo) return moment(currentContract.dateTo).toDate();
        }
        return null;
    }

    calculateMinDateForDateTo(rowIndex) {
        const contracts = this.state.element?.contracts;
        if (contracts.length > 0) {
            const currentContract = contracts[rowIndex];
            if (currentContract.dateFrom) {
                return moment(currentContract.dateFrom).toDate();
            }
        }
        return null;
    }

    contractDateFromTemplate(rowData, column) {
        const rowIndex = column.rowIndex;
        const dateFrom = rowData.dateFrom;
        const disabled = (moment(dateFrom).isSameOrBefore(moment(), this.contractDayMode.view) && rowData.id);
        const canEdit = this.authService.isUserInAnyRole('ROLE_USER_CONTRACT_ACCESS');
        return (
            <div style={{ minWidth: '120px', maxWidth: '200px' }}>
                <InputCalendarComponent
                    id={`contractDateFrom${rowIndex}`}
                    name='dateFrom'
                    value={rowData.dateFrom}
                    stateField={`element.contracts[${rowIndex}]`}
                    showLabel={false}
                    onChange={this.handleChange}
                    insideTable
                    viewMode={canEdit ? this.props.viewMode : 'VIEW'}
                    validator={this.validator}
                    validators='required'
                    disabled={disabled}
                    minDate={(disabled || this.state.element?.contracts.length === 1)
                        ? null : this.calculateMinDateForDateFrom(rowIndex)}
                    maxDate={this.calculateMaxDateForDateFrom(rowIndex)}
                    showClear
                    onAfterStateChange={() => {
                        this.setContractsDatesTo();
                    }}
                    dateFormatMoment={this.contractDayMode.dateFormatMoment}
                    view={this.contractDayMode.view}
                    dateFormat={this.contractDayMode.dateFormat}
                    placeholder={this.contractDayMode.placeholder}
                    yearNavigator={this.contractDayMode.yearNavigator}
                    showIcon
                />
            </div>
        );
    }

    contractDateToTemplate(rowData, props) {
        const rowIndex = props.rowIndex;
        const canEdit = this.authService.isUserInAnyRole('ROLE_USER_CONTRACT_ACCESS');
        return (
            <div style={{ minWidth: '120px', maxWidth: '180px' }}>
                <InputCalendarComponent
                    id={`contractDateTo${rowIndex}`}
                    name='dateTo'
                    value={rowData.dateTo}
                    stateField={`element.contracts[${rowIndex}]`}
                    showLabel={false}
                    onChange={this.handleChange}
                    insideTable
                    minDate={this.calculateMinDateForDateTo(rowIndex)}
                    viewMode={canEdit ? this.props.viewMode : 'VIEW'}
                    validator={this.validator}
                    validators='not_required'
                    disabled
                    dateFormatMoment={this.contractDayMode.dateFormatMoment}
                    view={this.contractDayMode.view}
                    dateFormat={this.contractDayMode.dateFormat}
                    placeholder={this.contractDayMode.placeholder}
                    yearNavigator={this.contractDayMode.yearNavigator}
                    showIcon
                />
            </div>
        );
    }


    absenceDateFromTemplate(rowData, column) {
        const rowIndex = column.rowIndex;

        let validators = `required`;
        if (rowData.dateTo != null) {
            validators += `|date_from_less_than_date_to:${rowIndex}`;
        }
        return (
            <div style={{ minWidth: '120px', maxWidth: '200px' }}>
                <InputCalendarComponent
                    id={`absenceDateFrom${rowIndex}`}
                    label={t('employee.absence.dateFrom')}
                    name='dateFrom'
                    value={rowData.dateFrom}
                    stateField={`element.absences[${rowIndex}]`}
                    showLabel={false}
                    onChange={this.handleChange}
                    insideTable
                    viewMode={this.props.viewMode}
                    validator={this.validator}
                    validators={validators}
                    showClear
                    showIcon
                />
            </div>
        );
    }
    absenceDateToTemplate(rowData, props) {
        const rowIndex = props.rowIndex;
        let validators = `required`;

        if (rowData.dateFrom != null) {
            validators += `|date_to_must_be_bigger_than_date_from:${rowIndex}`;
        }
        return (
            <div style={{ minWidth: '120px', maxWidth: '200px' }}>
                <InputCalendarComponent
                    id={`absenceDateTo${rowIndex}`}
                    label={t('employee.absence.dateTo')}
                    name='dateTo'
                    value={rowData.dateTo}
                    stateField={`element.absences[${rowIndex}]`}
                    showLabel={false}
                    onChange={this.handleChange}
                    insideTable
                    viewMode={this.props.viewMode}
                    validator={this.validator}
                    validators={validators}
                    showIcon
                />
            </div>
        );
    }

    contractTypeTemplate(rowData, props) {
        const rowIndex = props.rowIndex;
        const canEdit = this.authService.isUserInRole('ROLE_USER_EDIT') && this.isUserInRole('ROLE_USER_CONTRACT_ACCESS');
        return (
            <div style={{ minWidth: '150px', maxWidth: '200px' }}>
                <InputDropdownComponent
                    id={`contractType${rowIndex}`}
                    name='contractType'
                    label={t('employee.details.contractType')}
                    value={rowData.contractType}
                    stateField={`element.contracts[${rowIndex}]`}
                    showLabel={false}
                    options={this.state.contractTypes}
                    optionLabel='label'
                    dataKey='enumValue'
                    onChange={this.handleChange}
                    insideTable
                    viewMode={canEdit ? this.props.viewMode : 'VIEW'}
                    validator={this.validator}
                    validators='required'
                    colClass='p-2'
                />
            </div>
        );
    }

    absenceReasonTemplate(rowData, props) {
        const rowIndex = props.rowIndex;
        const { element } = this.state;
        let options = this.state.absenceReasons;

        if (element && element.absences) {
            let absence = element.absences[rowIndex];
            if (absence.absenceReason) {
                let reason = absence.absenceReason;
                if (reason.status.enumValue === 'REMOVED') {
                    let copy = [...this.state.absenceReasons];
                    copy.push(reason);
                    options = copy;
                }
            }
        }

        return (
            <div style={{ minWidth: '150px', maxWidth: '200px' }}>
                <InputDropdownComponent
                    id={`absenceReason${rowIndex}`}
                    name='absenceReason'
                    label={t('employee.absence.absenceReason')}
                    value={rowData.absenceReason}
                    stateField={`element.absences[${rowIndex}]`}
                    showLabel={false}
                    options={options}
                    optionLabel='reason'
                    onChange={this.handleChange}
                    insideTable
                    viewMode={this.props.viewMode}
                    validator={this.validator}
                    validators='required'
                    colClass='p-2'
                />
            </div>
        );
    }
    contractPriceTemplate(rowData, props) {
        const rowIndex = props.rowIndex;
        return (
            <InputNumberComponent
                id={`contractPrice${rowIndex}`}
                name='value'
                label={t('employee.details.price')}
                value={rowData.price.value}
                stateField={`element.contracts[${rowIndex}].price`}
                showLabel={false}
                onChange={this.handleChange}
                insideTable
                viewMode={this.props.viewMode}
                validator={this.validator}
                validators='required'
                mode='currency'
                currency='PLN'
                locale='pl-PL'
            />
        );
    }

    contractCostTemplate(rowData, props) {
        const rowIndex = props.rowIndex;
        return (
            <InputNumberComponent
                id={`contractCost${rowIndex}`}
                name='value'
                label={t('employee.details.cost')}
                value={rowData.cost.value}
                stateField={`element.contracts[${rowIndex}].cost`}
                showLabel={false}
                onChange={this.handleChange}
                insideTable
                viewMode={this.props.viewMode}
                validator={this.validator}
                validators='required'
                mode='currency'
                currency='PLN'
                locale='pl-PL'
            />
        );
    }

    contractsActionsTemplate(rowData, props) {
        const rowIndex = props.rowIndex;
        const dateFrom = rowData.dateFrom;
        const disabled = moment(dateFrom).isSameOrBefore(moment(), this.contractDayMode.view) && rowData.id;
        return (
            <span>
                <ActionLink
                    iconName='mdi-delete'
                    iconSide='left'
                    iconSize='icon-large'
                    handleClick={(e) => {
                        let contracts = this.state.element.contracts.filter((c) => c !== rowData);
                        this.setState(
                            (prevState) => ({
                                element: {
                                    ...prevState.element,
                                    contracts,
                                },
                            }),
                            () => this.setContractsDatesTo(rowIndex)
                        );
                    }}
                    variant='blue'
                    className='edit-blue-link'
                    key={'delete-button'}
                    disabled={disabled}
                />
            </span>
        );
    }
    absencesActionsTemplate(rowData, props) {
        const rowIndex = props.rowIndex;
        const dateFrom = rowData.dateFrom;
        return (
            <span>
                <ActionLink
                    iconName='mdi-delete'
                    iconSide='left'
                    iconSize='icon-large'
                    handleClick={(e) => {
                        let absences = this.state.element.absences.filter((c) => c !== rowData);
                        this.setState(
                            (prevState) => ({
                                element: {
                                    ...prevState.element,
                                    absences,
                                },
                            }),
                            () => { }
                        );
                    }}
                    variant='blue'
                    className='edit-blue-link'
                    key={'delete-button'}
                />
            </span>
        );
    }
    documentTypeTemplate(rowData, props) {
        const rowIndex = props.rowIndex;
        const { element } = this.state;
        let options = this.state.documentTypes;

        if (element && element.documents) {
            let document = element.documents[rowIndex];
            if (document.documentType) {
                let type = document.documentType;
                if (type.status.enumValue === 'REMOVED') {
                    let copy = [...this.state.documentTypes];
                    copy.push(type);
                    options = copy;
                }
            }
        }
        return (
            <div style={{ minWidth: '150px' }}>
                <InputDropdownComponent
                    id={`documentType${rowIndex}`}
                    name='documentType'
                    label={t('employee.document.documentType')}
                    value={rowData.documentType}
                    stateField={`element.documents[${rowIndex}]`}
                    showLabel={false}
                    options={options}
                    optionLabel='name'
                    onChange={this.handleChange}
                    insideTable
                    viewMode={this.props.viewMode}
                    validator={this.validator}
                    validators='required'
                    colClass='p-2'
                />
            </div>
        );
    }
    documentTypeNumberTemplate(rowData, props) {
        const rowIndex = props.rowIndex;
        return (
            <div style={{ minWidth: '120px' }}>
                <InputTextComponent
                    id={`docNumber${rowIndex}`}
                    name='docNumber'
                    label={t('employee.document.number')}
                    colClass='col-md-3'
                    stateField={`element.documents[${rowIndex}]`}
                    value={rowData.docNumber}
                    showLabel={false}
                    onChange={this.handleChange}
                    viewMode={this.props.viewMode}
                    insideTable
                    validator={this.validator}
                    validators="required|max:30"
                />
            </div>
        );
    }
    documentDateToTemplate(rowData, props) {
        const rowIndex = props.rowIndex;
        return (
            <div style={{ minWidth: '120px', maxWidth: '200px' }}>
                <InputCalendarComponent
                    id={`absenceDateTo${rowIndex}`}
                    label={t('employee.document.dateTo')}
                    name='dateTo'
                    value={rowData.dateTo}
                    stateField={`element.documents[${rowIndex}]`}
                    showLabel={false}
                    onChange={this.handleChange}
                    insideTable
                    viewMode={this.props.viewMode}
                    validator={this.validator}
                    validators="required"
                    showIcon
                />
            </div>
        );
    }
    documentActionsTemplate(rowData, props) {
        const rowIndex = props.rowIndex;
        return (
            <span>
                <ActionLink
                    iconName='mdi-delete'
                    iconSide='left'
                    iconSize='icon-large'
                    handleClick={(e) => {
                        let documents = this.state.element.documents.filter((c) => c !== rowData);
                        this.setState(
                            (prevState) => ({
                                element: {
                                    ...prevState.element,
                                    documents,
                                },
                            }),
                        );
                    }}
                    variant='blue'
                    className='edit-blue-link'
                    key={'delete-button'}
                />
            </span>
        );
    }

    setContractsDatesTo() {
        const contracts = this.state.element.contracts;
        contracts.forEach((c) => {
            c.dateTo = null;
            const dates = contracts.map((c2) => c2.dateFrom).filter((d) => d > c.dateFrom);
            if (dates.length > 0) {
                const minDate = new Date(Math.min(...dates.map((date) => date.getTime())));
                c.dateTo = moment(minDate).subtract(1, this.contractDayMode.view).toDate();
            }
        });
        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                contracts: contracts,
            },
        }));
    }

    isPdfButtonRendered() {
        return false;
    }

    canAddNewContract() {
        if ((this.props.viewMode === 'NEW' && this.state.element?.contracts?.length === 0) || this.props.viewMode === 'EDIT') {
            return true;
        }
        return false;
    }
    createQueryString(queryObject = {}) {
        let queryString = Object.keys(queryObject)
            .filter((key) => queryObject[key] && !(Array.isArray(queryObject[key]) && !queryObject[key].length))
            .map((key) => {
                return Array.isArray(queryObject[key]) ? queryObject[key].map(item => `${encodeURIComponent(key)}=${encodeURIComponent(item)}`).join('&') : `${encodeURIComponent(key)}=${encodeURIComponent(queryObject[key])}`;
            }).join('&');
        return queryString ? `?${queryString}` : "";
    };
    canAddNewAbsence() {
        if ((this.props.viewMode === 'NEW') || this.props.viewMode === 'EDIT') {
            return true;
        }
        return false;
    }
    canAddNewDocument() {
        if ((this.props.viewMode === 'NEW') || this.props.viewMode === 'EDIT') {
            return true;
        }
        return false;
    }
    absenceConfirmedTemplate(rowData, props) {
        const { rowIndex } = props;
        return (
            <InputCheckboxComponent
                id={`absenceConfirmed`}
                name='absenceConfirmed'
                label={''}
                stateField={`element.absences[${rowIndex}]`}
                value={rowData.absenceConfirmed}
                validator={this.validator}
                validators='not_required'
                onChange={this.handleChange}
                viewMode={'EDIT'}
                insideTable={true}
                labelOnRight={true}
                disabled={this.props.viewMode === 'VIEW'}
            />
        );
    }
    inputColorComponent() {
        return '';
        // if (this.state?.element?.categories)
        //     return <div className="row mb-4" style={{ marginTop: "7px", marginBottom: "-12px" }}>
        //         <div>
        //             <label id={`-label-id`} className='p-label' style={{ marginBottom: '-6px', marginTop: "12px" }}>
        //                 {t('employee.categories')}
        //             </label>
        //         </div>
        //         {this.state?.element?.categories.map(category => {
        //             return (
        //                 <div className='row' style={{
        //                     display: 'flex',
        //                     justifyContent: 'start',
        //                     alignItems: 'center',
        //                     width: 'fit-content',
        //                     gap: '10px'
        //                 }}>
        //                     <div className='col-xl-1 col-lg-1 col-md-1 col-sm-1'>
        //                         <IconColorComponent componentStyle={{ marginLeft: "-50px", cursor: 'none' }} componentClassName={"col-1"} fontSize={"22px"} icon={category.icon.value} color={category.color.value} />
        //                     </div>
        //                     <div style={{
        //                         width: 'fit-content',
        //                     }}>
        //                         <span style={{
        //                             fontSize: '12px',
        //                             width: 'fit-content'
        //                         }}>
        //                             {category.name}
        //                         </span>
        //                     </div>
        //                 </div>
        //             )
        //         })}
        //     </div>
    }

    getPreparedExpirationStatusIcon(documentStatus) {
        switch (documentStatus.enumValue) {
            case 'EXPIRED':
                return (
                    <div className='row' style={{ display: 'flex', justifyContent: 'center', width: '100px' }}>
                        {
                            <IconColorComponent componentClassName="col-1" fontSize={"22px"} icon={Constants.ALERT_ICON} color={Constants.RED} tootltipText={documentStatus.label} />
                        }
                    </div>
                )
            case 'SOON_EXPIRED':
                return (
                    <div className='row' style={{ display: 'flex', justifyContent: 'center', width: '100px' }}>
                        {
                            <IconColorComponent componentClassName="col-1" fontSize={"22px"} icon={Constants.ALERT_ICON} color={Constants.ORANGE} tootltipText={documentStatus.label} />
                        }
                    </div>
                )
            case 'HANDLED':
                return (
                    <div className='row' style={{ display: 'flex', justifyContent: 'center', width: '100px' }}>
                        {
                            <IconColorComponent componentClassName="col-1" fontSize={"22px"} icon={Constants.HANDLED_ICON} color={Constants.GREEN} tootltipText={documentStatus.label} />
                        }
                    </div>
                )
            default:
                return null;
        }
    }
    documentStatusTemplate(rowData) {
        if (rowData?.expirationStatus) {
            let documentStatus = rowData.expirationStatus;
            return documentStatus.enumValue ? (
                this.getPreparedExpirationStatusIcon(documentStatus)
            ) : null
        }
    }

    refreshCurrentElement() {
        this.setElement();
    }

    documentStatusAction(rowData) {
        let expirationStatus = rowData?.expirationStatus;
        return (
            <div style={{ alignItems: 'center' }}>
                {expirationStatus != null && (
                    <ActionLink
                        iconName='mdi-eye'
                        iconSide='left'
                        iconSize='icon-large'
                        handleClick={(e) => {
                            this.setState({
                                docActionDialogVisible: true,
                                selectedItem: rowData
                            });
                        }}
                        variant='blue'
                        className='edit-blue-link'
                        key={'view-button'}
                    ></ActionLink>)
                }
                {(this.state.docActionDialogVisible && this.state.selectedItem === rowData) && (
                    <DocumentExpirationStatusDialog
                        visible={true}
                        className='car-dialog'
                        key={`car-dialog-${this.state.element?.id}`}
                        handled={rowData?.alarmHandled}
                        viewMode={this.state.dialogViewMode}
                        afterConfirmation={(e) => {
                            this.hideDocStatusDialog();
                            this.showSuccessMessage('Obsłużono alarm');
                            this.refreshCurrentElement();
                        }}
                        blockUi={this.blockUi}
                        unblockUi={this.unblockUi}
                        _isMounted={this._isMounted}
                        onHide={() => {
                            this.hideDocStatusDialog();
                        }}
                        elementId={rowData?.id}
                        element={rowData}
                        employeeId={this.state.element?.id}
                        style={{
                            width: 'auto',
                            height: 'auto'
                        }}
                    />
                )}
            </div>
        )
    }

    hideDocStatusDialog() {
        this.setState({
            docActionDialogVisible: false
        });
    }

    navigateToLink() {
        const { link } = this.state.element;
        window.location.href = link;
    }

    getLinkComponentIfRequired() {
        const { element } = this.state;
        //wyswietl komponent jesli jest link, null kiedy nie ma

        return element.link ?
        <div
         style={{
            display: 'flex',
            justifyContent: 'start',
            alignItems: 'baseline',
            gap: '15px',
            marginTop: '4%',
            width: '200%'
        }}>
            <span><InsertLinkIcon sx={{ width: 20, height: 20 }} /></span>
            <span className='p-label' style={{
                color: this.state.linkColor,
                cursor: 'pointer'
            }}
                onMouseEnter={(e) => {
                    this.setState({
                        linkColor: 'gray'
                    })
                }}
                onMouseLeave={(e) => {
                    this.setState({
                        linkColor: 'black'
                    })
                }}
                onClick={(e) => {
                    this.navigateToLink()
                }}
            >{t('employee.document.link')}
            </span>

        </div> : null
    }

    getLinkComponentIfRequiredEditViewMode() {
        const { element } = this.state;
        //wyswietl komponent jesli jest link, null kiedy nie ma
        return <div
            style={{
                display: 'flex',
                justifyContent: 'start',
                alignItems: 'baseline',
                gap: '15px',
                width: '200%'
            }}>
            <span><InsertLinkIcon sx={{ width: 20, height: 20 }} /></span>
            <InputTextComponent
                id='link-input-text'
                name='link'
                label={'Link'}
                colClass={'col-xl-5 col-lg-5 col-md-5 col-sm-5'}
                value={this.state.element.link}
                validators='not_required'
                validator={this.validator}
                onChange={this.handleChange}
                viewMode={this.props.viewMode}
            />
        </div>
    }


    getPhoneNumberIfRequired() {
        const { element } = this.state;
        //wyswietl komponent jesli jest numer telefonu, null kiedy nie ma
        return (element.phoneNumber || this.props.viewMode !== 'VIEW') ?
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'start',
                    alignItems: 'baseline',
                    gap: '15px',
                    width: '200%'
                }}>
                <span><LocalPhoneIcon sx={{ width: 20, height: 20 }} /></span>
                <InputTextComponent
                    id='phone-number'
                    name='phoneNumber'
                    label={'Numer telefonu'}
                    colClass={'col-xl-5 col-lg-5 col-md-5 col-sm-5'}
                    value={this.state.element.phoneNumber}
                    validators='not_required|phone|max:20'
                    validator={this.validator}
                    onChange={this.handleChange}
                    viewMode={this.props.viewMode}
                />
            </div> : null;
    }

    categoriesItemTemplate(category) {
        const checked = this.state.selectedCategories?.filter(c => c == category.id).length > 0;
        return (
            <div className='p-multiselect-token'>
                <Checkbox
                checked={checked}
                />
                <IconColorComponent
                    componentClassName="-col-1"
                    componentStyle={{
                        padding: '5px 0px 0px 0px'
                    }}
                    fontSize={"22px"}
                    icon={category?.icon?.value}
                    color={category?.color?.value}
                    tootltipText={category?.name}
                />
                <span>
                    {category?.name}
                </span>
            </div>
        );
    }


    getUserCategoriesComponent() {
        const { categories } = this.state.element;
        const { viewMode } = this.props;
        if ((!categories || categories.length === 0) && viewMode === 'VIEW' ) {
            return null;
        }
        return (
            <div
                id='categories-edit-component'
                style={{
                    display: 'flex',
                    justifyContent: 'start',
                    alignItems: 'baseline',
                    gap: '15px',
                    marginTop: '1%',
                }}
            >
                <span>
                    <CategoryIcon sx={{ width: 20, height: 20 }} />
                </span>
                <InputMultiListBoxComponent
                    id="categories"
                    name="categories"
                    label={t('project.details.categories')}
                    colClass={'col-xl-10 col-lg-10 col-md-6 col-sm-6'}
                    value={this.state.element.categories}
                    options={this.state.categories}
                    optionLabel="name"
                    viewMode={this.props.viewMode}
                    onChange={this.handleChange}
                    dataKey="id"
                    validator={this.validator}
                    filter
                />

            </div>
        );
    }

    getDummyIcon() {
        return <div>{<GroupIcon sx={{ visibility: 'hidden', width: 20 }} />}</div>
    }

    getUserRolesEditComponent() {
        const { roleOptions } = this.state;
        return roleOptions.map((roleElement, index) => {
            const ids = this.state.element?.roles.map(x => x.id);
            return (
                <>
                    <div id={`role-${index}`} style={{
                        display: 'flex',
                        justifyContent: 'start',

                    }}>
                        {index === 0 ?
                            <BadgeIcon sx={{ width: 20 }} />
                            :
                            this.getDummyIcon()
                        }
                        <div
                            className='row'
                            style={{
                                marginLeft: "4px",
                                width: '200%',
                            }}>
                            {index === 0 ?
                                <InputTextComponent
                                    name='phoneNumber'
                                    label={t('internaluser.role')}  //label niepotrzebny dla innych rekordow,
                                    colClass={'col-md-12'}
                                    viewMode={'VIEW'}
                                /> : null}
                            <div style={{
                                display: 'flex',
                                justifyContent: 'start',
                                alignItems: 'center',
                                height: 'auto',
                                width: '100%'
                            }}>
                                <Checkbox
                                    id='role-checkbox'
                                    sx={{
                                        marginLeft: '-12px',
                                        marginRight: '',
                                        marginTop: ''
                                    }}
                                    color='black'
                                    checked={ids.includes(roleElement.id)}
                                    onChange={(e) => {
                                        let element = this.state.element;
                                        if (e.target.checked) {
                                            element.roles.push(roleElement);
                                        } else {
                                            element.roles = element.roles.filter((x) => x.id !== roleElement.id)
                                        }

                                        this.setState({
                                            element: element
                                        })
                                    }}
                                />
                                <div style={{
                                    //TODO
                                     minWidth: '80px',
                                     width: "200%",
                                }}>
                                    <span id={'role-name'}
                                        style={{
                                            marginRight: '40px',
                                            fontFamily: 'Poppins',
                                            fontStyle: 'normal',
                                            fontWeight: 'normal',
                                            fontSize: '13px',
                                            lineHeight: '16px',
                                            color: 'black',
                                        }}
                                    >
                                        {roleElement.name}
                                    </span>
                                </div>
                                <div id='help-icon'>
                                    <HelpCenterIcon
                                        data-pr-tooltip={roleElement?.description}
                                        className='employeeAbsences'
                                        sx={{
                                            cursor: 'pointer',
                                            marginLeft: 'auto'
                                        }}
                                    />
                                    <Tooltip target=".employeeAbsences" style={{ fontSize: '11px', height: '40px' }} />
                                </div>
                            </div>
                        </div>
                    </div>
                    {index === roleOptions.length - 1 ?
                        //wyswietlenie pod ostatnią rolą
                        <span>{this.validator.message('', '', '', 'at_least_one_role_selected')}</span>
                        : null}
                </>
            )
        })
    }

    countLeftDays() {
        const { annualLeaves } = this.state.element;
        let overdue = annualLeaves.annualLeaveOverdue !== undefined ? annualLeaves.annualLeaveOverdue : 0;
        let annualLeave = annualLeaves.annualLeaveTotalDays !== undefined ? annualLeaves.annualLeaveTotalDays : 0;
        let usedDays = annualLeaves.annualLeaveUsedDays !== undefined ? annualLeaves.annualLeaveUsedDays : 0;
        let leftDays = overdue + annualLeave - usedDays;
        let annualLeavesAfterChange = structuredClone(this.state.element.annualLeaves);
        annualLeavesAfterChange.annualLeaveLeftDays = leftDays;
        this.setState((prevState) => ({
            ...prevState,
            element: {
                ...prevState.element,
                annualLeaves: annualLeavesAfterChange
            }
        }));

    }

    getAnnualLeavesComponent(){
        const {element} = this.state;
        const viewMode = this.props.viewMode;

        if (!this.authService.isUserInRole('ROLE_LEAVE_REQUEST_MANAGE_EDIT')) {
            return null;
        }

            return (
                <div className='row'>
                {/* <div className='col'> */}
                 <div style={{
                        display: 'flex',
                        justifyContent: 'start',
                        alignItems: 'baseline',
                        //gap: '15px',
                        width: '100%',
                    }}>
                    {<BeachAccess sx={{ width: 20, height: 20 }}/>}
                    <div style={{
                        marginLeft: "11px",
                        marginRight: "20px",
                    }}>
                        {/* <span>Liczba dni urlopu</span> */}
                                    <InputNumberComponent
                                    id={`annualLeaveOverdue-id`}
                                    name='annualLeaveOverdue'
                                    label={'Urlop zaległy'}
                                    value={this.state.element.annualLeaves.annualLeaveOverdue}
                                    colClass={'col-12'}
                                    stateField={`element.annualLeaves`}
                                    onAfterStateChange={() => this.countLeftDays()}
                                    onChange={this.handleChange}
                                    viewMode={this.props.viewMode}
                                    validator={this.validator}
                                    validators='required'
                                />
                                <InputNumberComponent
                                    id={`annualLeaveTotalDays-id`}
                                    name='annualLeaveTotalDays'
                                    label={'Urlop przysługujący w bieżącym roku'}
                                    value={this.state.element.annualLeaves.annualLeaveTotalDays}
                                    colClass={'col-12'}
                                    stateField={`element.annualLeaves`}
                                    onChange={this.handleChange}
                                    onAfterStateChange={() => this.countLeftDays()}
                                    viewMode={this.props.viewMode}
                                    validator={this.validator}
                                    validators='required'
                                />
                                    <InputNumberComponent
                                    id={`annualLeaveUsedDays-id`}
                                    name='annualLeaveUsedDays'
                                    label={'Urlop wykorzystany w bieżącym roku'}
                                    value={this.state.element.annualLeaves.annualLeaveUsedDays}
                                    colClass={'col-12'}
                                    stateField={`element.annualLeaves`}
                                    onChange={this.handleChange}
                                    onAfterStateChange={() => this.countLeftDays()}
                                    viewMode={this.props.viewMode}
                                    validator={this.validator}
                                    validators='required'
                                />
                                <InputNumberComponent
                                    id={`annualLeaveLeftDays-id`}
                                    name='annualLeaveLeftDays'
                                    label={'Urlop pozostały do wykorzystania'}
                                    value={this.state.element.annualLeaves.annualLeaveLeftDays}
                                    colClass={'col-12'}
                                    stateField={`element.annualLeaves`}
                                    onChange={this.handleChange}
                                    viewMode={this.props.viewMode}
                                    validator={this.validator}
                                    validators='not_required'
                                    disabled= {true}
                                />
                                </div>
                               </div>
                               </div>
                            //    </div>

            )


    }


    getUserRolesComponent() {
        const { element } = this.state;
        const viewMode = this.props.viewMode;
        
        return viewMode === 'VIEW' ?
            <>
                {
                    element?.roles.map((roleElement, index) => {
                        return (
                            <div className='col' style={{
                               // marginTop:'-17px' //mniejszy odstęp pomiędzy rolami -  zakomentowałam, bo nagłówki się rozjedzały w trybie VIEW
                            }}>
                                <div id={`role-${index}`} style={{
                                    display: 'flex',
                                    justifyContent: 'start',
                                }}>
                                    {index === 0 ?
                                        <div>{<AssignmentIndIcon sx={{ width: 20 }} />}</div>
                                        :
                                        this.getDummyIcon()}
                                    <div style={{
                                        marginLeft: '16px',
                                    }}>
                                        <InputTextComponent
                                            name='phoneNumber'
                                            label={index === 0 ? t('internaluser.role') : ''}
                                            value={roleElement?.name}
                                            colClass={'col-md-12'}
                                            validators='not_required|phone|max:20'
                                            validator={this.validator}
                                            onChange={this.handleChange}
                                            viewMode={this.props.viewMode}
                                        />
                                        <div className='row p-inputtext-view' style={{
                                            color: '#737373',
                                            marginTop: '3%',
                                            fontSize: "11px",
                                            marginLeft: '0px',
                                        }}>
                                            {roleElement?.description}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
            </>
            :
            <div id='rolesCheckboxes'>
                {this.getUserRolesEditComponent()}
            </div>
    }


    getUserAppPermissions() {
        const isLogin = this.state.loginAppRoles.some(role => this.state.element.roles.map(x => x.id).includes(role.id))
        const isPortalLogin = this.state.portalLoginRoles.some(role => this.state.element.roles.map(x => x.id).includes(role.id))

        return (
            <>
                <div style={{
                    display: 'flex',
                    justifyContent: 'start',
                    alignItems: 'baseline',
                    gap: '15px',
                    marginTop: '4%',
                    width: '200%',
                }}>
                    <span><LockIcon sx={{ width: 20, height: 20 }} /></span>
                    <InputTextComponent
                        name='phoneNumber'
                        label={t('employee.user-access')}
                        value={''}
                        validators='not_required|phone|max:20'
                        validator={this.validator}
                        onChange={this.handleChange}
                        viewMode={'VIEW'}
                    />
                </div>
                <div className='row' style={{
                    marginLeft: '21px'
                }}>
                    {isLogin ?
                        <div id='mobile-app-checkbox-green' style={{
                            display: 'flex',
                            justifyContent: 'start',
                            gap: '10px'
                        }}>
                            <CheckBoxIcon sx={{ color: 'green' }} />
                            <span className=''
                                style={{
                                    fontFamily: 'Poppins',
                                    fontStyle: 'normal',
                                    fontWeight: 'normal',
                                    fontSize: '12px',
                                    lineHeight: '16px',
                                    color: 'black',
                                    display: 'flex',
                                    alignItems: 'center'
                                }}>
                                {t('global.mobileApp')}
                            </span>
                        </div>
                        :
                        <div id='mobile-app-checkbox-red' style={{
                            display: 'flex',
                            justifyContent: 'start',
                            gap: '10px',
                        }}>
                            <DisabledByDefault sx={{ color: 'red', borderRadius: '122px' }} />
                            <span className=''
                                style={{
                                    fontFamily: 'Poppins',
                                    fontStyle: 'normal',
                                    fontWeight: 'normal',
                                    fontSize: '12px',
                                    lineHeight: '16px',
                                    color: 'black',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}>
                                {t('global.mobileApp')}
                            </span>
                        </div>
                    }
                    {isPortalLogin ?
                        <div id='portal-checkbox-green' style={{
                            display: 'flex',
                            justifyContent: 'start',
                            gap: '10px',
                            marginTop: '1%'
                        }}>
                            <CheckBoxIcon sx={{ color: 'green' }} />
                            <span className=''
                                style={{
                                    fontFamily: 'Poppins',
                                    fontStyle: 'normal',
                                    fontWeight: 'normal',
                                    fontSize: '12px',
                                    lineHeight: '16px',
                                    color: 'black',
                                    display: 'flex',
                                    alignItems: 'center'
                                }}>
                                {t('global.portal')}
                            </span>
                        </div>
                        :
                        <div id='portal-checkbox-red'  style={{
                            display: 'flex',
                            justifyContent: 'start',
                            gap: '10px',
                        }}>
                            <DisabledByDefault sx={{ color: 'red', borderRadius: '122px' }} />
                            <span className=''
                                style={{
                                    fontFamily: 'Poppins',
                                    fontStyle: 'normal',
                                    fontWeight: 'normal',
                                    fontSize: '12px',
                                    lineHeight: '16px',
                                    color: 'black',
                                    display: 'flex',
                                    alignItems: 'center'
                                }}>
                                {t('global.portal')}
                            </span>
                        </div>
                    }
                </div>
            </>
        )
    }

    getSubgroupManager() {
        if (!this.authService.getProfile().projectExternalManagerEnabled) {
            return null;
        }

        const { element } = this.state;
        const manager = element.externalManager;
        //const roleAdmin = this.authService.isUserInRole('ROLE_USER_TYPE_ADMIN')
        //const roleEm = this.authService.isUserInRole('ROLE_USER_TYPE_EXTERNAL_MANAGER')

        return (manager || this.props.viewMode !== 'VIEW') ? (<div style={{
            display: 'flex',
            justifyContent: 'start',
            marginTop: '3%'
        }}>
            {<SupervisedUserCircleIcon />}
            <div id='subgroup-manager' className='col-xl-12 col-lg-12 col-md-12 col-sm-12'
                style={{
                    marginLeft: "11px",
                }}>
                <InputDropdownComponent
                    id={`external-manager`}
                    name="externalManager"
                    label={t('employee.subgroupManagerLabel')}
                    colClass={'col-xl-9 col-lg-8 col-md-8 col-sm-7'}
                    value={manager}
                    valueView={manager?.fullName}
                    dataKey='id'
                    options={this.state.externalManagers}
                    optionLabel='fullName'
                    viewMode={this.props.viewMode}
                    validator={this.validator}
                    validators='not_required'
                    onChange={this.handleChange}
                    filter
                    filterBy="fullName"
                    showClear
                    //disabled={roleEm && !roleAdmin} przekopiowane ze starej formatki
                />
            </div>
        </div>
        ) : null
    }


    getSubcontractor() {
        const { element } = this.state;
        const { subcontractor } = element;
        if (!this.authService.isUserInRole('ROLE_SUBCONTRACTOR_EDIT')) {
            return null;
        }

        return subcontractor && !(this.props.viewMode === 'EDIT' || this.props.viewMode === 'NEW') ?
            (
                <div className='col'>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'start',
                    }}>
                        {<EngineeringIcon />}
                        <div style={{
                            marginLeft: "11px",
                        }}>
                            <InputTextComponent
                                name='phoneNumber'
                                label={t('employee.details.subcontractorName')}
                                value={subcontractor?.name}
                                colClass={'col-md-12'}
                                validators='not_required'
                                validator={this.validator}
                                onChange={this.handleChange}
                                viewMode={this.props.viewMode}
                            />
                        </div>
                    </div>
                </div>
            ) :
            (this.props.viewMode === 'EDIT' || this.props.viewMode === 'NEW') ?
                <div>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'start',
                    }}>
                        {<EngineeringIcon />}
                        <div className='col-xl-10 col-lg-10 col-md-6 col-sm-6'
                            style={{
                                marginLeft: "11px",
                            }}>
                            <InputDropdownComponent
                                id='subcontractor'
                                name='subcontractor'
                                label={t('employee.details.subcontractorName')}
                                colClass={'col-xl-12 col-lg-12 col-md-6 col-sm-6'}
                                value={element.subcontractor}
                                validator={this.validator}
                                options={this.state.subcontractors}
                                onChange={this.handleChange}
                                viewMode={this.props.viewMode}
                                dataKey='id'
                                filter={true}
                                showClear={true}
                                validators='not_required'
                                optionLabel='name'
                            />
                        </div>
                    </div>
                </div> : null
    }


    getLastNameFirstNameComponent() {
        return (
            <div className='row'>
                <div className='col'>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'start',
                        alignItems: 'baseline',
                        gap: '15px',
                        width: '200%',
                    }}>
                        <span><BadgeIcon sx={{ width: 20, height: 20 }} /></span>
                        <InputTextComponent
                            id='lastName'
                            name='lastName'
                            label={t('employee.details.lastName')}
                            value={this.state.element.lastName}
                            colClass={'col-xl-5 col-lg-5 col-md-6 col-sm-6'}
                            validator={this.validator}
                            validators='required|alpha_space_dash|max:100'
                            keyfilter={/^[A-ZĄĆĘŁŃÓŚŹŻąćęłńóśźż\s-]*$/i}
                            onChange={this.handleChange}
                            viewMode={this.props.viewMode}
                        />
                    </div>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'start',
                        alignItems: 'baseline',
                        gap: '15px',
                        width: '200%',
                    }}>
                        {this.getDummyIcon()}
                        <InputTextComponent
                            id='firstName'
                            name='firstName'
                            label={t('employee.details.firstName')}
                            value={this.state.element.firstName}
                            colClass={'col-xl-5 col-lg-5 col-md-6 col-sm-6'}
                            validator={this.validator}
                            validators='required|alpha_space_dash|max:100'
                            keyfilter={/^[A-ZĄĆĘŁŃÓŚŹŻąćęłńóśźż\s-]*$/i}
                            onChange={this.handleChange}
                            viewMode={this.props.viewMode}
                        />
                    </div>
                </div>

            </div>
        )
    }

    renderDetails() {
        const isPortalLogin = this.state.portalLoginRoles.some(role => this.state.element.roles.map(x => x.id).includes(role.id))
        const isAppLogin = this.state.loginAppRoles.some(role => this.state.element.roles.map(x => x.id).includes(role.id))
        
        const emailRequired = (isPortalLogin || isAppLogin) ? 'required' : 'not_required';
        const emailDomain = this.state.emailDomain;

        if (this.state.element && this.state.element.categories) {
            this.state.element.categories.forEach(c => {
                if (!this.state.categories.map((x) => x.id).includes(c.id)) {
                    this.state.categories.push(c);
                }
            });
        }

        const canViewPrices = this.authService.isUserInAnyRole('ROLE_USER_CONTRACT_ACCESS')
        //check roli, czy terenowy/biurowy
        const isEmployee = this.state.employeeRoles.some(role => this.state.element.roles.map(x => x.id).includes(role.id))
        const isOfficeWorker = this.state.officeWorkersRoles.some(role => this.state.element.roles.map(x => x.id).includes(role.id))

        let priceStrategyPredicate = undefined;
        if (isEmployee && isOfficeWorker) { //biurowy i terenowy jednoczesnie
            priceStrategyPredicate = this.authService.getProfile().userContractPriceStrategy !== Constants.NONE || this.authService.getProfile().userContractPriceStrategy === Constants.ALL;
        } else if (isEmployee && !isOfficeWorker) { //jest pracownikiem terenowym;
            priceStrategyPredicate = this.authService.getProfile().userContractPriceStrategy !== Constants.NONE
        } else if (!isEmployee && isOfficeWorker) {//jest pracownikiem biurowym;
            priceStrategyPredicate = this.authService.getProfile().userContractPriceStrategy === Constants.ALL
        }

        return (
            <React.Fragment>
                <DivContainer colClass='row'>
                    <DivContainer colClass='col-12'>
                        <TabView activeIndex={this.state.activeIndex} onTabChange={(e) => {
                            this.navigationContext.addOrUpdateParam('activeIndex', e.index);
                            this.setState({ activeIndex: e.index });
                        }} >
                            <TabPanel header={t('employee.basicInfo')}>
                                <div className='row profile'>
                                    <div className='col-12 col-xs-12 col-sm-12 col-md-4 details-card-wrapper'>
                                        <Card
                                            className='data-card'
                                            header={
                                                <div className='card-header-with-icon-container'>
                                                    <i className='mdi mdi-card-account-details'/>
                                                    <span>{t('employee.personalData')}</span>
                                                </div>
                                            }
                                        >

                                            {this.getLastNameFirstNameComponent()}
                                            {this.state.element.email || (this.props.viewMode === 'NEW' || this.props.viewMode === 'EDIT')  ?
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'start',
                                                        alignItems: 'baseline',
                                                        gap: '15px',
                                                        width: '200%',
                                                    }}>
                                                    <span><AlternateEmailIcon sx={{ width: 20, height: 20 }} /></span>
                                                    <InputTextComponent
                                                        id='email'
                                                        name='email'
                                                        label={t('employee.details.email')}
                                                        colClass={'col-xl-5 col-lg-5 col-md-4 col-sm-4'}
                                                        value={this.state.element.email}
                                                        validator={this.validator}
                                                        validators={`${emailRequired}|email_domain:${emailDomain}|max:100`}
                                                        onChange={this.handleChange}
                                                        viewMode={this.props.viewMode}

                                                    />
                                                </div> : null
                                            }

                                            {this.getPhoneNumberIfRequired()}
                                            <div id='link-component'>
                                            {this.props.viewMode === 'VIEW' ? this.getLinkComponentIfRequired() : this.getLinkComponentIfRequiredEditViewMode()}
                                            </div>
                                            {this.getUserCategoriesComponent()}
                                        </Card>
                                    </div>
                                    <div className='col-12 col-xs-12 col-sm-12 col-md-4 details-card-wrapper'>
                                        <Card
                                            className='data-card'
                                            header={
                                                <div className='card-header-with-icon-container'>
                                                    <SecurityIcon
                                                        alt=""
                                                        sx={{ width: 20, height: 20, fontSize: 40 }}
                                                    >
                                                    </SecurityIcon>
                                                    <span>{t('employee.permissions')}</span>
                                                </div>
                                            }
                                        >

                                            {this.getUserRolesComponent()}
                                            {this.getUserAppPermissions()}
                                            {this.getSubgroupManager()}
                                        </Card>
                                    </div>
                                    {this.authService.isUserInAnyRole('ROLE_SUBCONTRACTOR_EDIT', 'ROLE_LEAVE_REQUEST_MANAGE_EDIT') &&
                                        <div className='col-12 col-xs-12 col-sm-12 col-md-4 details-card-wrapper'>
                                            <Card
                                                className='data-card'
                                                header={
                                                    <div className='card-header-with-icon-container'>
                                                        <WidgetsIcon
                                                            alt=""
                                                            sx={{ width: 20, height: 20 }}
                                                        >
                                                        </WidgetsIcon>
                                                        <span>{t('employee.otherDataCard')}</span>
                                                    </div>
                                                }
                                            >
                                                {this.getSubcontractor()}
                                                {this.getAnnualLeavesComponent()}
                                            
                                            </Card>
                                        </div>
                                    }
                                </div>
                            </TabPanel>
                            <TabPanel id='contracts-tab' header={t('employee.contract.label')}>
                                <DataTable
                                    id='contracts'
                                    value={this.state.element.contracts}
                                    responsiveLayout='scroll'
                                    emptyMessage={t('list.empty')}
                                >
                                    <Column
                                        field='dateFrom'
                                        header={t('employee.details.dateFrom')}
                                        body={this.contractDateFromTemplate.bind(this)}
                                    ></Column>
                                    <Column
                                        field='dateTo'
                                        header={t('employee.details.dateTo')}
                                        body={this.contractDateToTemplate.bind(this)}
                                    ></Column>

                                    <Column
                                        field='contractType'
                                        header={t('employee.details.contractType')}
                                        body={this.contractTypeTemplate.bind(this)}
                                    ></Column>
                                    {canViewPrices && priceStrategyPredicate ? (
                                        <Column
                                            field='price.value'
                                            header={t('employee.details.price')}
                                            body={this.contractPriceTemplate.bind(this)}
                                        ></Column>
                                    ) : null
                                    }
                                    {canViewPrices ? (
                                        <Column
                                            field='cost.value'
                                            header={t('employee.details.cost')}
                                            body={this.contractCostTemplate.bind(this)}
                                        ></Column>
                                    ) : null
                                    }
                                    {(this.props.viewMode !== 'VIEW' && canViewPrices) ? (
                                        <Column header='' body={this.contractsActionsTemplate.bind(this)}></Column>
                                    ) : null}
                                </DataTable>
                                {
                                    this.state.element.contracts.length !== 0 ?
                                        <div aria-live='assertive'>
                                            {this.validator.message(
                                                'contracts',
                                                'Kontrakty',
                                                this.state.element.contracts,
                                                `contract_from_create_date_exists:${this.state.element.createDate}|contract_no_duplicates`
                                            )}
                                        </div>
                                        :
                                        <div aria-live='assertive'>
                                            {this.validator.message(
                                                'contracts',
                                                'Kontrakty',
                                                this.state.element,
                                                `contract_must_be_defined`
                                            )}
                                        </div>
                                }
                                <DivContainer>
                                    <ActionLink
                                        label={t('employee.details.addContractButton')}
                                        id='add-contract-button'
                                        iconName='mdi-plus'
                                        iconSide='left'
                                        iconSize='icon-large'
                                        variant='blue'
                                        className='float-right'
                                        key={'add-activity-button'}
                                        handleClick={() => {
                                            const contracts = this.state.element.contracts;
                                            const maxDate = new Date(Math.max(...contracts.map((c) => c.dateFrom.getTime())));
                                            let newDateFrom = moment().toDate();
                                            if (maxDate && moment(maxDate).isSameOrAfter(moment(), this.contractDayMode.view)) {
                                                newDateFrom = moment(maxDate).add(1, this.contractDayMode.view).toDate();
                                            }
                                            contracts.unshift({ dateFrom: newDateFrom, price: {}, cost: {} });

                                            this.setState(
                                                (prevState) => ({
                                                    element: {
                                                        ...prevState.element,
                                                        contracts,
                                                    },
                                                }),
                                                () => this.setContractsDatesTo()
                                            );
                                        }}
                                        rendered={canViewPrices && this.canAddNewContract()}
                                    />
                                </DivContainer>
                            </TabPanel>
                            <TabPanel header={t('employee.document.label')}>
                                <DivContainer colClass='col-12'>
                                    <DataTable
                                        id='documents'
                                        value={this.state.element.documents}
                                        responsiveLayout='scroll'
                                        emptyMessage={t('list.empty')}
                                    >
                                        <Column
                                            field='documentType'
                                            header={t('employee.document.documentType')}
                                            body={this.documentTypeTemplate.bind(this)}
                                        ></Column>
                                        <Column
                                            field='docNumber'
                                            header={t('employee.document.number')}
                                            body={this.documentTypeNumberTemplate.bind(this)}
                                        ></Column>

                                        <Column
                                            field='dateTo'
                                            header={t('employee.document.dateTo')}
                                            body={this.documentDateToTemplate.bind(this)}
                                        ></Column>
                                        <Column
                                            field='expirationStatus'
                                            header={t('employee.document.status')}
                                            body={this.documentStatusTemplate.bind(this)}
                                            headerStyle={{
                                                width: '200px',
                                            }}
                                            bodyStyle={{
                                                width: '200px',
                                                textAlign: 'center'
                                            }}

                                        ></Column>
                                        {this.props.viewMode !== 'EDIT' && (
                                            <Column
                                                field=''
                                                header={t('employee.documentStatusAction')}
                                                body={this.documentStatusAction.bind(this)}
                                            />
                                        )}
                                        {this.props.viewMode !== 'VIEW' ? (
                                            <Column header='' body={this.documentActionsTemplate.bind(this)}></Column>
                                        ) : null}

                                    </DataTable>
                                </DivContainer>
                                <DivContainer>
                                    <ActionLink
                                        label={t('employee.document.addDocumentButton')}
                                        id='add-document-button'
                                        iconName='mdi-plus'
                                        iconSide='left'
                                        iconSize='icon-large'
                                        variant='blue'
                                        className='float-right'
                                        key={'add-activity-button'}
                                        handleClick={() => {
                                            const documents = this.state.element.documents;
                                            documents.unshift({ documentType: null, docNumber: '', dateTo: null });
                                            this.setState(
                                                (prevState) => ({
                                                    element: {
                                                        ...prevState.element,
                                                        documents,
                                                    },
                                                }),

                                            );
                                        }}
                                        rendered={this.canAddNewDocument()}
                                    />
                                </DivContainer>
                            </TabPanel>
                            <TabPanel header={t('employee.absence.label')}>
                                <DataTable
                                    id='absences'
                                    value={this.state.element.absences}
                                    responsiveLayout='scroll'
                                    emptyMessage={t('list.empty')}
                                >
                                    <Column
                                        field='dateFrom'
                                        header={t('employee.absence.dateFrom')}
                                        body={this.absenceDateFromTemplate.bind(this)}
                                    ></Column>
                                    <Column
                                        field='dateTo'
                                        header={t('employee.absence.dateTo')}
                                        body={this.absenceDateToTemplate.bind(this)}
                                    ></Column>
                                    <Column
                                        field='reason'
                                        header={t('employee.absence.reason')}
                                        body={this.absenceReasonTemplate.bind(this)}
                                    ></Column>
                                    <Column
                                        field='absenceConfirmed'
                                        header={t('employee.absence.confirmed')}
                                        body={this.absenceConfirmedTemplate.bind(this)}
                                        align={'center'}
                                    ></Column>
                                    {this.props.viewMode !== 'VIEW' ? (
                                        <Column header='' body={this.absencesActionsTemplate.bind(this)}></Column>
                                    ) : null}
                                </DataTable>
                                <div aria-live='assertive'>
                                    {this.validator.message(
                                        'absences',
                                        'Nieobecności',
                                        this.state.element.absences,
                                        "no_overlapping_dates"
                                    )}
                                </div>
                                <DivContainer>
                                    <ActionLink
                                        label={t('employee.absence.addAbsenceButton')}
                                        id={'add-absence-button'}
                                        iconName='mdi-plus'
                                        iconSide='left'
                                        iconSize='icon-large'
                                        variant='blue'
                                        className='float-right'
                                        key={'add-activity-button'}
                                        handleClick={() => {
                                            const absences = this.state.element.absences;
                                            absences.unshift({ dateFrom: null, dateTo: null, absenceReason: null });
                                            this.setState(
                                                (prevState) => ({
                                                    element: {
                                                        ...prevState.element,
                                                        absences,
                                                    },
                                                }),
                                                // () => this.setContractsDatesTo()
                                            );
                                        }}
                                        rendered={this.canAddNewAbsence()}
                                    />
                                </DivContainer>
                            </TabPanel>
                            {this.props.viewMode !== "NEW" && isEmployee ?
                                <TabPanel header={'Dni w kraju'}>
                                    <DataTable
                                        id='alarms'
                                        value={this.state.element?.alarms}
                                        responsiveLayout='scroll'
                                        emptyMessage={t('list.empty')}>
                                        <Column field="alarmDay"
                                            header="Rok"
                                            body={(row) => { return row.alarmDay.slice(0, 4) }}
                                        ></Column>
                                        <Column field="country.name" header="Kraj"></Column>
                                        <Column field="employeeDaysInCountry" header="Liczba dni" ></Column>
                                        <Column
                                            field=""
                                            style={{ width: "250px" }}
                                            header="Status"
                                            body={(row) => {
                                                return <div style={{ fontSize: "14px" }}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        e.preventDefault();
                                                        if (this.props.viewMode === "EDIT" && row.status === "UNSERVED") {
                                                            const alarms = this.state.element?.alarms;
                                                            const alarm = alarms.find(el => el.id === row.id);
                                                            alarm.status = "SERVED";
                                                            this.setState((prevState) => ({
                                                                element: {
                                                                    ...prevState.element,
                                                                    alarms
                                                                }

                                                            }))
                                                        }
                                                    }}> {<AlarmStatusIconTemplateComponent row={row} viewMode={this.props.viewMode} />}</div>
                                            }}
                                        ></Column>
                                    </DataTable>
                                </TabPanel>
                                : null
                            }
                            {this.props.viewMode !== "NEW" && <TabPanel header={t('employee.projectLabel')}>
                                <DivContainer colClass='col-12'>
                                    <DataTable id='projects'
                                        value={this.state.userProjects}
                                        responsiveLayout='scroll'
                                        emptyMessage={t('list.empty')}>
                                        <Column field="name" header="Nazwa" sortable={true}></Column>
                                        <Column field="dateFrom" header="Data od" sortable={true}></Column>
                                        <Column field="dateTo" header="Data do" sortable={true}></Column>
                                    </DataTable>
                                </DivContainer>
                            </TabPanel>}
                            {this.props.viewMode !== 'NEW' ? (
                                <TabPanel header={t('project.details.logsTabHeader')}>
                                    <div style={{
                                        maxHeight: "fit-content"
                                    }}>
                                        <LogEntryListContainer
                                            objectType='USER'
                                            objectId={this.props.elementId}
                                            expandFilters={false}
                                            renderHeader={false}
                                            minHeight='fit-content' //domyslnie jest 900px
                                            renderInsideCard={false} //zeby wyrownac wzgledem innych zakladek
                                            viewClassname={''} //zeby wyrownac wzgledem innych zakladek
                                        />
                                    </div>
                                </TabPanel>
                            ) : null}
                        </TabView>
                        {this.state.showConfirmBlockDialog && this.state.element.status.enumValue === 'ACTIVE' ? (
                            <YesNoDialog
                                visible={this.state.showConfirmBlockDialog}
                                header={t('employee.blockUserHeader')}
                                name='visible'
                                onChange={(type, x, target) => {
                                    if (target.value) {
                                        this.blockAccount();
                                    } else {
                                        this.hideBlockConfirmation();
                                    }
                                }}
                                onHide={() => {
                                    this.hideBlockConfirmation();
                                }}
                            >
                                {t('internaluser.details.dialogBlockQuestion')}
                            </YesNoDialog>
                        ) : this.state.showConfirmUnblockDialog && this.state.element.status.enumValue !== 'ACTIVE' ? (
                            <YesNoDialog
                                visible={this.state.showConfirmUnblockDialog}
                                header={t('employee.dialogUnblockHeader')}
                                name='visible'
                                onChange={(type, x, target) => {
                                    if (target.value) {
                                        this.unblockAccount();
                                    } else {
                                        this.hideUnblockConfirmation();
                                    }
                                }}
                                onHide={() => {
                                    this.hideUnblockConfirmation();
                                }}
                            >
                                {t('internaluser.details.dialogUnblockQuestion')}
                            </YesNoDialog>
                        ) : null}
                    </DivContainer>
                </DivContainer>
            </React.Fragment>
        );
    }

    renderTopPanel() {
        const isNew = this.props.viewMode === 'NEW';
        const status = this.state?.element?.status;
        const {firstName, lastName} = this.state;
        const isActive = status?.enumValue === 'ACTIVE';


        const label = isNew ? 'Nowy użytkownik' : (!lastName ? '' : `${lastName} ${firstName}`);
        const initials = isNew ? '' : (!lastName ? '' : `${lastName.slice(0, 1)} ${firstName.slice(0, 1)}`);

        return <React.Fragment>
            <Avatar
                alt=""
                src=""
                sx={{ width: 80, height: 80, fontSize: 40 }}
                id="user-header-avatar"
            >
                {initials}
            </Avatar>
            <span className='top-panel-large-label' id="top-panel-user-name">{label}</span>
            {isNew ? null : (
                <React.Fragment>
                    <CopyLink textToCopy={label} />
                    <div id='top-panel-user-status'>
                        <Chip
                            label={status?.label}
                            className={isActive ? 'user-status-active' : 'user-status-blocked'}
                        />
                    </div>
                </React.Fragment>
            )}
            </React.Fragment>
    }

    renderView() {
        return (
            <DivContainer colClass='details-main'>
                <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)} />
                <BlockUi
                    tag='div'
                    blocking={this.state.blocking || this.state.loading}
                    loader={this.loader}
                >
                    <ConfirmDialog
                        visible={this.state.confirmDialog?.visible}
                        onHide={() => this.setConfirmDialogVisibility(false)}
                        message={this.translate(`${this.state.confirmDialog?.message}`)}
                        header={this.translate(`${this.state.confirmDialog?.header}`)}
                        icon={`pi ${this.state.confirmDialog?.header}`}
                        accept={() => this.setConfirmDialogVisibility(false)}
                        rejectClassName='display-none'
                        acceptClassName='confirm-dialog-accept'
                    />
                    <div className='row' style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                        <div className='col-6'>{this.renderBackLink()}</div>
                    </div>
                    <DivContainer colClass='col-12 details-main-link-container'>
                        <DivContainer colClass='row'>
                            <DivContainer colClass='col-12'>{this.state.loading ? null : this.renderCard()}</DivContainer>
                        </DivContainer>
                    </DivContainer>
                    {this.state.downloadingPdf && <PdfDownloadSpinner />}
                </BlockUi>
            </DivContainer>
        );
    }

    itemTemplate(category) {
        return <div
            id='category'
            style={{
                display: 'flex',
                justifyContent: 'start',
                gap: "20px",
                alignItems: 'center',
                alignContent: 'center',
                width: 'fit-content'
            }}>
            <IconColorComponent
                componentClassName="col-1"
                componentStyle={{
                    padding: '5px 0px 0px 0px'
                }}
                fontSize={"22px"}
                icon={category?.icon?.value}
                color={category?.color?.value}
            />
            <span id='category-name'>
               {category?.name}
            </span>
        </div>
    }
}


UserDetailsContainer.defaultProps = {
    backUrl: '#/user-list',
    cancelUrl: '/#/user/details',
    editUrl: '/#/user/edit',
    viewUrl: '/#/user/details/',
    lazy: true,
};

UserDetailsContainer.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    editUrl: PropTypes.string,
};
export default withRouter(withTranslation()(UserDetailsContainer));
